import React from 'react';
import { ShieldAlert, Handshake, MessageCircle, RefreshCw, Award, DollarSign, Eye } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
const guaranteeIcons = [DollarSign, Eye, RefreshCw, Handshake, MessageCircle, ShieldAlert];
export function GuaranteeSection() {
  const {
    t
  } = useLang();
  return <section className="py-24 bg-dark relative" data-id="element-123" data-mp="ercvdc3kudr4">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-124" data-mp="jtbzwpb1zgpn">
        <div className="text-center mb-16" data-id="element-125" data-mp="jqpr6mcfev5u">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 mb-6" data-id="element-126" data-mp="nt2ocmd3xkr0">
            <ShieldAlert className="w-8 h-8 text-gold" data-id="element-127" data-mp="sm5hwuhvwu77" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-128" data-mp="xkgs56c3d6py">
            {t.guarantee.title} <br className="hidden md:block" data-id="element-129" data-mp="12jjzixfjnp13" />
            <span className="text-gold" data-id="element-130" data-mp="12kv3ax8zows7">{t.guarantee.titleHighlight}</span>
          </h2>
          <div className="text-lg text-gray-400 max-w-2xl mx-auto space-y-4" data-id="element-131" data-mp="17imu1nxwecut">
            <p data-id="element-132" data-mp="25sylow6dxoit">{t.guarantee.p1}</p>
            <p data-id="element-133" data-mp="25t8e0qewk7ro">{t.guarantee.p2}</p>
            <p className="text-white font-bold" data-id="element-134" data-mp="20t3vkuufp2yt">{t.guarantee.p3}</p>
          </div>

          <div className="mt-10 max-w-3xl mx-auto bg-dark-100 border border-gold/30 rounded-2xl p-6 md:p-8" data-id="element-135" data-mp="20v6ts25qq2em">
            <div className="inline-flex items-center gap-2 text-gold text-xs font-bold uppercase tracking-wider mb-3" data-id="element-136" data-mp="1rs5rkcjzwvg8">
              <Award className="w-4 h-4" data-id="element-137" data-mp="2oiy97emkuvk4" />
              {t.guarantee.confidenceBadge}
            </div>
            <p className="text-lg md:text-xl text-white font-medium leading-relaxed" data-id="element-138" data-mp="2jj2399ubku1x">
              {t.guarantee.confidenceA}{' '}
              <span className="text-gold" data-id="element-139" data-mp="2er27zup72pbo">
                {t.guarantee.confidenceHighlight}
              </span>
              {t.guarantee.confidenceB}
            </p>
          </div>
        </div>

        <div className="bg-dark-100 rounded-3xl border border-white/10 p-8 md:p-12 shadow-2xl" data-id="element-140" data-mp="37ah7j85nplft">
          <h3 className="text-2xl font-bold text-center text-white mb-10" data-id="element-141" data-mp="32gmtak8tlyo4">
            {t.guarantee.guaranteeTitle}
          </h3>

          <div className="grid md:grid-cols-2 gap-x-12 gap-y-8" data-id="element-142" data-mp="10n04udkeql0i">
            {t.guarantee.items.map((item, index) => {
            const Icon = guaranteeIcons[index];
            return <div key={index} className="flex items-start gap-4" data-id="element-143" data-mp="qt00wf0v3ltd" data-mpi={index}>
                  <div className="bg-dark p-3 rounded-xl border border-white/5 shrink-0" data-id="element-144" data-mp="vscpb47dt0y2">
                    <Icon className="w-6 h-6 text-gold" data-id="element-145" data-mp="htd1fyrp0q2y" />
                  </div>
                  <div data-id="element-146" data-mp="mtit3exyqcl1">
                    <h4 className="text-white font-bold mb-1" data-id="element-147" data-mp="mutx9fvblmco">
                      {item.promise}
                    </h4>
                    <p className="text-gray-400 text-sm" data-id="element-148" data-mp="7yco8valsjta">{item.meaning}</p>
                  </div>
                </div>;
          })}
          </div>

          <div className="mt-12 pt-8 border-t border-white/10 text-center" data-id="element-149" data-mp="22baun3t6mwbc">
            <p className="text-xl font-bold text-white" data-id="element-150" data-mp="279cehqyfmznv">
              {t.guarantee.closingA}{' '}
              <span className="text-gold" data-id="element-151" data-mp="3rqd9bm2vmvw4">
                {t.guarantee.closingHighlight}
              </span>
              {t.guarantee.closingB}
            </p>
          </div>
        </div>
      </div>
    </section>;
}